var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPackageIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 25,
    fill: "none",
    viewBox: "0 0 26 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#97A2AB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M7.51 11.428l4.782 2.333c.406.197.664.6.664 1.043v5.557c0 .442-.258.847-.664 1.043L7.51 23.737c-.337.164-.733.164-1.07 0l-4.782-2.332c-.406-.2-.661-.607-.658-1.05v-5.55c0-.443.257-.848.664-1.044l4.782-2.333c.335-.162.729-.162 1.064 0z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#97A2AB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M1.191 14.175l5.787 2.822 5.786-2.822M6.978 23.853v-6.856"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#97A2AB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M19.466 11.428l4.782 2.333c.406.197.663.6.664 1.043v5.557c0 .442-.258.847-.664 1.043l-4.782 2.333c-.337.164-.733.164-1.07 0l-4.783-2.332c-.405-.2-.66-.607-.657-1.05v-5.55c0-.443.257-.848.663-1.044l4.783-2.333c.335-.162.729-.162 1.064 0z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#97A2AB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M13.147 14.175l5.787 2.822 5.786-2.822M18.934 23.853v-6.856"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#97A2AB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M13.488 1.122l4.782 2.332c.406.197.663.601.663 1.044v5.556c0 .443-.257.847-.663 1.044l-4.782 2.332c-.337.165-.734.165-1.07 0l-4.783-2.332c-.406-.2-.66-.606-.657-1.05v-5.55c0-.443.257-.847.663-1.044l4.783-2.332c.335-.163.729-.163 1.064 0z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#97A2AB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M7.17 3.868l5.786 2.822 5.787-2.822M12.956 13.547V6.69"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackageIcon);
export default __webpack_public_path__ + "static/media/package-icon.e84f7aaee2d3f28860c307fdf02a2b04.svg";
export { ForwardRef as ReactComponent };